export default "__VITE_ASSET__CqcTHCmK__"